module.exports = __webpack_public_path__ + "static/media/9DESA14.f093a322.jpg";